// TODO: This will be moved to a different service when UMS frontend is exported out
export const FORESIGHT_ACCOUNT_IDS = [
  'A1FFGHGYY30GWS', // STORES-REGULATORY-RISK
  'A2XEOXGTMVKJLD', // TSE-REGULATORY-RISK
  'A1SNLNJJBXK5US', // BRP-REGULATORY-RISK
  'A2E0LK8H6EFOQI', // ORC-REGULATORY-RISK
  'A1QR4YJQLF8FRR', // GRA-RISK
];

export const FORESIGHT_DEFAULT_ROLES_INTERNAL = [
  {
    name: 'Admin',
  },
  {
    name: 'Operator',
  },
  {
    name: 'Legal',
  },
  {
    name: 'Public Policy',
  },
  {
    name: 'Compliance',
  },
  {
    name: 'Tech',
  },
  {
    name: 'Public Relations',
  },
  {
    name: 'Business',
  },
];
